import { getPropertyValueByCode } from "src/services/property";
import { Element } from "src/types/element.ts";

import { useFormatPropertyValue } from "./property/useFormatProperty";

export const useFormatElementPropertyValue = () => {
  const formatPropertyValue = useFormatPropertyValue();

  const formatElementPropertyValue = (
    element: Element | Element["elements"][number],
    propertyCode: string | null | undefined
  ) => {
    if (!element || !propertyCode) return null;
    const property = getPropertyValueByCode(element.properties, propertyCode);
    if (!property) return null;
    return formatPropertyValue(property);
  };

  return formatElementPropertyValue;
};
